export default "__VITE_ASSET__DXvwfZmy__"